export * from "./random-questions-quote.component";
